import {Droppler} from "../Droppler";
import {InputWithSuffix} from "../InputWithSuffix";


const PackageSizeField = {
    name: 'PackageSizeField',
    components: {
        Droppler,
        InputWithSuffix
    },
    props: {
        name: {
            type: String,
            required: true
        },
        label: String,
        imgSrc: String,
        value: [String, Number],
        packageType: [String, Number],
        invalid: Boolean,
    },
    computed: {
        isTooltipAvailable() {
            return parseInt(this.packageType, 10) === 3;
        },
        isDisabled() {
            return parseInt(this.packageType, 10) === 2;
        },
        mask() {
            return /^\d+$/;
        },
        realValue() {

            // deleting default 0 in input after all delete
            if(this.value <= 0)
                return '';

            return this.value + '';
        }
    },
    methods: {
        openTooltip() {
            if (this.isTooltipAvailable) {
                this.$refs.tooltip.open();
            }
        },
        onBlur() {
            this.$emit('validateRequestField', this.name);
            if (this.isTooltipAvailable) {
                this.$refs.tooltip.close();
            }
        },
        onInput(value) {
            this.$emit('input', +value);
        }
    },
    template: `
        <Droppler openOn="manual"
                ref="tooltip"
                classes="tooltip-theme-primary tooltip-theme-primary--shallow"
                position="top middle">
            <InputWithSuffix
                suffix="cm"
                type="text"
                :name="name"
                inputmode="numeric"
                slot="drop-trigger"
                :placeholder="label"
                suffixWidth="40"
                :mask="mask"
                :disabled="isDisabled"
                :isInvalid="invalid"
                :value="realValue"
                @input="onInput"
                @blur="onBlur"
                @focus="openTooltip"
            />
            <img :src="imgSrc" slot="drop-content" height="134"/>
        </Droppler>
    `
};

export const PackageWidth = {
    name: 'PackageWidth',
    components: {
        PackageSizeField
    },
    props: {
        packageType: [String, Number],
        value: [String, Number],
        invalid: Boolean,
        label: {
            type: String,
            default: 'Szerokość'
        },
        name: String,
    },
    data() {
        return {
            imgSrc: require('../../../images/parcel/paleta_szerokosc.png')
        }
    },
    computed: {
        realName() {
            return this.name || 'width';
        }
    },
    template: `
        <PackageSizeField :label="label"
                            :name="realName"
                            :invalid="invalid"
                            :packageType="packageType"
                            :imgSrc="imgSrc"
                            :value="value" 
                            v-on="$listeners" />
    `
};

export const PackageHeight = {
    name: 'PackageHeight',
    components: {
        PackageSizeField
    },
    props: {
        packageType: [String, Number],
        value: [String, Number],
        invalid: Boolean,
        label: {
            type: String,
            default: 'Wysokość'
        },
        name: String,
    },
    data() {
        return {
            imgSrc: require('../../../images/parcel/paleta_wysokosc.png')
        }
    },
    computed: {
        realName() {
            return this.name || 'height';
        }
    },
    template: `
        <PackageSizeField :label="label"
                            :name="realName"
                            :invalid="invalid"
                            :packageType="packageType" 
                            :value="value"
                            :imgSrc="imgSrc"
                            v-on="$listeners" />
    `
};

export const PackageLength = {
    name: 'PackageLength',
    components: {
        PackageSizeField
    },
    props: {
        packageType: [String, Number],
        value: [String, Number],
        invalid: Boolean,
        label: {
            type: String,
            default: 'Długość'
        },
        name: String,
    },
    data() {
        return {
            imgSrc: require('../../../images/parcel/paleta_dlugosc.png')
        }
    },
    computed: {
        realName() {
            return this.name || 'length';
        }
    },
    template: `
        <PackageSizeField :label="label"
                            :name="realName"
                            :invalid="invalid"
                            :packageType="packageType" 
                            :value="value"
                            :imgSrc="imgSrc"
                            v-on="$listeners" />
    `
};